__turbopack_context__.v({
  "container": "index-module-scss-module__QXBiMW__container",
  "cta": "index-module-scss-module__QXBiMW__cta",
  "description": "index-module-scss-module__QXBiMW__description",
  "eyebrow": "index-module-scss-module__QXBiMW__eyebrow",
  "section": "index-module-scss-module__QXBiMW__section",
  "title": "index-module-scss-module__QXBiMW__title",
});
